/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {ExplorePageComponent} from './explore-page.component';
import {canAccessNetworkExplore} from './network-explore-access';

export function exploreStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
  states.add('app.explore', {
    url: '/explore',
    views: {
      'content@app': {
        component: ExplorePageComponent
      },
      'title@app': stateTitleView()
    },
    data: {
      title: 'Explore'
    },
    onEnter: function() {
      const localUserProfile = adnRouterHelper.services.localUserProfile();
      const localUserPermissions = adnRouterHelper.services.localUserPermissions();
      if (!canAccessNetworkExplore(localUserProfile, localUserPermissions)) {
        return adnRouterHelper.services.state().target('app.home', null, {location: false, inherit: false});
      }
    }
  });
  return states.build();
}
